import { gql } from "@apollo/client";
import FormText from "controls/FormText";
import useData from "hooks/useData";
import useIsAdmin from "hooks/useIsAdmin";
import { Refresh } from "mdi-material-ui";
import React from "react";
import makeConfirmActionDialog from "readmin_pages/shared/makeConfirmActionDialog";

export const AiGameStatsRequestReimportDialog = makeConfirmActionDialog({
  mutationName: "aiGameStatsRequestReimport",
  paramName: "aiGameStatsRequestId",
  action: "Re-import AI Events",
  successMessage: "Re-import started. Please check the game page in Readmin a few minutes later to see the results.",
  useButtonProps: ({ aiGameStatsRequestId }) => {
    const isAdmin = useIsAdmin();
    const [data] = useData(
      gql`
        query AiGameStatsRequestReimportButtonQuery($aiGameStatsRequestId: ID!) {
          aiGameStatsRequest(id: $aiGameStatsRequestId) {
            id
            reimportable
          }
        }
      `,
      { aiGameStatsRequestId },
      { skip: !isAdmin },
    );

    return {
      icon: <Refresh />,
      hidden: !isAdmin,
      // Nothing imported yet means nothing to replace, and the mutation would refuse it anyway.
      disabled: !data?.aiGameStatsRequest?.reimportable,
      content: "Re-import AI Events",
    };
  },
  useConfirmFormDialogProps: () => {
    return {
      children: <FormText uiStringKey="readmin.ai_game_stats_request.reimport_confirm" />,
    };
  },
});
